import ProductDetailsPanel from './ProductDetailsPanel';
export default ProductDetailsPanel;
